import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import '../../styles.less'
import { getOverallBudgetReportReport } from '../../../../redux/actions/overallBudgetReport'
import OverallBudgetReportWidget from '../../../../widgets/overallBudgetReport/OverallBudgetReportWidget'
import { MONTHS_TH } from '../../../../constants/date'

export default function OverallBudgetReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')
  const pageNumber = 0
  const pageSize = 0

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getOverallBudgetReportReport()
      setSchema(response.model)
      // console.log('response==>', response)
      // setSchema(mockSchema.model)
      // console.log('mockSchema==>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isReport>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <OverallBudgetReportWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}

// ขอให้มีกรองข้อมูล/ค้นหา >>>>>  
/*
ปีงบประมาณเริ่มต้น
ปีงบประมาณสิ้นสุด
สำนัก
ช่วงเวลาวันที่เริ่มต้น
เวลาวันที่สิ้นสุด
เดือน
เลขที่โครงการ
รหัสโครงการ
สถานะโครงการ
วันที่เริ่มต้นโครงการ
วันที่สิ้นสุดโครงการ
*/
const mock = {
  "affectedRows": 0,
  "message": null,
  "success": true,
  "didError": false,
  "errorMessage": null,
  "model": {
      "header": "รายงานภาพรวมการเบิกจ่าย และเงินเหลือคืนของเงินอุดหนุนโครงการ",
      "subHeader": "",
      "disabled": false,
      "forms": {
          "header": "รายงานภาพรวมการเบิกจ่าย",
          "searchForm": {
            "budgetYearStart": {
              "name": "budgetYearStart",
              "label": "ปีงบประมาณเริ่มต้น",
              "value": null
            },
            "budgetYearEnd": {
                "name": "budgetYearEnd",
                "label": "ปีงบประมาณสิ้นสุด",
                "value": null
            },
            "department": {
                "options": [
                  {
                      "label": "ฝ่ายอำนวยการ",
                      "value": "00"
                  },
                  {
                      "label": "สำนัก 1",
                      "value": "01"
                  },
                  {
                      "label": "สำนัก 2",
                      "value": "02"
                  },
                  {
                      "label": "สำนัก 3",
                      "value": "03"
                  },
                  {
                      "label": "สำนัก 4",
                      "value": "04"
                  },
                  {
                      "label": "สำนัก 5",
                      "value": "05"
                  },
                  {
                      "label": "สำนัก 6",
                      "value": "06"
                  },
                  {
                      "label": "สำนัก 7",
                      "value": "07"
                  },
                  {
                      "label": "สนย.",
                      "value": "08"
                  },
                  {
                      "label": "สภส.",
                      "value": "09"
                  },
                  {
                      "label": "ศรร.",
                      "value": "10"
                  },
                  {
                      "label": "ฝ่ายบริหารบุคคล",
                      "value": "11"
                  },
                  {
                      "label": "ฝ่ายเทคโนโลยีฯ",
                      "value": "12"
                  },
                  {
                      "label": "สำนักวิชาการและนวัตกรรม",
                      "value": "20"
                  },
                  {
                      "label": "ฝ่ายติดตามประเมินผล",
                      "value": "21"
                  },
                  {
                      "label": "ฝ่ายสื่อสารองค์กร",
                      "value": "13"
                  },
                  {
                      "label": "ฝ่ายบัญชีฯ",
                      "value": "14"
                  },
                  {
                      "label": "สำนัก 8",
                      "value": "15"
                  },
                  {
                      "label": "สำนัก 9",
                      "value": "16"
                  },
                  {
                      "label": "ฝ่ายตรวจสอบภายใน",
                      "value": "17"
                  },
                  {
                      "label": "กลุ่มงานวิชาการฯ",
                      "value": "18"
                  },
                  {
                      "label": "สำนักสื่อสารการตลาดเพื่อสังคม",
                      "value": "19"
                  },
                  {
                      "label": "สำนักผู้จัดการ",
                      "value": "90"
                  },
                  {
                      "label": "ศูนย์สัญญา",
                      "value": "22"
                  },
                  {
                      "label": "สำนัก 10",
                      "value": "23"
                  },
                  {
                      "label": "สสค.",
                      "value": "24"
                  },
                  {
                      "label": "สำนัก 11",
                      "value": "25"
                  },
                  {
                      "label": "ThaiHealth Academy",
                      "value": "26"
                  },
                  {
                      "label": "SOOK Enterprise",
                      "value": "27"
                  }
                ],
                "name": "department",
                "label": "สำนัก",
                "value": null
            },
            "startDate": {
                "name": "startDate",
                "label": "ช่วงเวลาวันที่เริ่มต้น",
                "value": null
            },
            "endDate": {
                "name": "endDate",
                "label": "เวลาวันที่สิ้นสุด",
                "value": null
            },
            "month": {
                "name": "month",
                "label": "เดือน",
                "options": MONTHS_TH,
                "value": null
            },
            "projectNo": {
                "name": "projectNo",
                "label": "เลขที่โครงการ",
                "value": ""
            },
            "projectCode": {
                "name": "projectCode",
                "label": "รหัสโครงการ",
                "value": ""
            },
            "projectStatus": {
                "name": "projectStatus",
                "label": "สถานะโครงการ",
                "options": [
                  { value: 1, label: 'ร่างข้อเสนอ' },
                  { value: 2, label: 'ยื่นข้อเสนอโครงการ' },
                  { value: 3, label: 'คัดกรอง' },
                  { value: 4, label: 'กลั่นกรอง' },
                  { value: 5, label: 'อนุมัติ' },
                  { value: 6, label: 'ดำเนินการ' },
                  { value: 7, label: 'รอยกเลิกโครงการ' },
                  { value: 9, label: 'ปิดโครงการ' },
                  { value: 8, label: 'สละสิทธิ์โครงการ' }
                ],
                "value": null
            },
            "projectStartDate": {
                "name": "projectStartDate",
                "label": "วันที่เริ่มต้นโครงการ",
                "value": null
            },
            "projectEndDate": {
                "name": "projectEndDate",
                "label": "วันที่สิ้นสุดโครงการ",
                "value": null
            },
          },
          
          "values": [
            {
              sequenceNo: 'sequenceNo',                   // ลำดับที่
              budgetYearApprove: 'budgetYearApprove',     // ปีงบอนุมัติ
              projectNo: 'projectNo',                     // เลขที่โครงการ
              projectCode: 'projectCode',                 // รหัสโครงการ
              projectName: 'projectName',                 // ชื่อโครงการ
              department: 'department',                   // สำนัก
              coordinatorName: 'coordinatorName',                 // ผู้ประสานงาน (สสส.)
              granteeName: 'granteeName',     // รับทุนในนาม
              granteeOrganizationName: 'granteeOrganizationName',       // องค์กรรับทุน
              responsinatorName: 'responsinatorName',           // ผู้รับผิดชอบโครงการ
              startDate: 'startDate',                     // วันเริ่มต้น
              endDate: 'endDate',                         // วันสิ้นสุด
              approvedBudget: 0,                          // วงเงินอนุมัติ
              projectStatus: 'projectStatus',             // สถานะโครงการ
              totalPeriods: 'totalPeriods',               // งวดทั้งหมดของโครงการ
              eFinSubStatus: 'eFinSubStatus',             // สถานะย่อยของ new e-fin
              statusChangeDate: 'statusChangeDate',       // วันที่เปลี่ยนสถานะย่อย
              currentPeriod: 'currentPeriod',             // งวดที่ ณ ปัจจุบันที่ดึงข้อมูล
              totalIncome: 0,                             // รายรับรวม(ตั้งแต่งวด1-งวดปัจจุบัน)
              interestIncome: 0,                          // รายได้ดอกเบี้ย(ตั้งแต่งวดที่ 1-งวดปัจจุบัน)ที่บันทึก
              totalExpense: 0,                            // รายจ่าย(ตั้งแต่งวดที่ 1-งวดปัจจุบัน)ที่บันทึก
              pendingExpense: 0,                          // ค่าใช้จ่ายค้างจ่าย
              remainingBalance: 0,                        // เงินคงเหลือ
              refundAmount: 0,                            // จำนวนเงินนำฝากคืน สสส.
              refundDate: 'refundDate',                   // วันที่นำฝาก/โอนคืน
              finalBalance: 0,                            // เงินคงเหลือ
              remarks: 'remarks'                          // หมายเหตุ
            }
        ]
      },
  }
}